import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';


interface ProductTypeConditionProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

@observer
export class ProductTypeCondition extends React.Component<ProductTypeConditionProps, any> {
	constructor(props) {
		super(props);

	}

	render() {

		const { values } = this.props;

		const comboValues = [
			{ text: 'General', value: '0' },
			{ text: 'Accommodation', value: '1' },
			{ text: 'Car rent', value: '2' },
			{ text: 'Transfer', value: '3' },
			{ text: 'Flight', value: '4' },
			{ text: 'Room', value: '5' }
		]
			;
		return (
			<React.Fragment>
				<div>

					<p style={{ margin: '7px' }}
					>Check the product type value in a QuoteEntry</p>

					<Row gutter={24}>
						<Col xs={12}>
							<DropdownView
								label='Product type'
								model={values && values["productType"]}
								required={true}
								disabled={this.props.mode == 'display'}
								onChanged={(e) => this.props.onFieldChange("productType", e.value)}
								options={comboValues}
								keyField='value'
								textField='text'
							/>
						</Col>
					</Row>

				</div>



			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/conditions/product-type.condition.tsx